'use client'
import { useState, useEffect, useRef } from 'react'

export function useCountUp(target, duration = 1400, decimals = 0) {
  const [v, setV] = useState(0)
  const ref = useRef(null)
  const started = useRef(false)

  useEffect(() => {
    if (!ref.current) return
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started.current) {
        started.current = true
        const start = performance.now()
        const tick = (t) => {
          const p = Math.min(1, (t - start) / duration)
          const eased = 1 - Math.pow(1 - p, 3)
          setV(target * eased)
          if (p < 1) requestAnimationFrame(tick)
          else setV(target)
        }
        requestAnimationFrame(tick)
      }
    }, { threshold: 0.3 })
    obs.observe(ref.current)
    return () => obs.disconnect()
  }, [target])

  return [ref, decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('ru-RU')]
}
